import Vue from 'vue';
import axios from 'axios';
import store from '@/store';

const ERROR_SIMULATOR_CUSTOMER_WITH_DEBT = 'Simulator_CustomerWithDebt'.toLowerCase();
const INVALID_IBAN = 'iban_invalid';
const GENERIC_ERROR = 'Generic_Error';

axios.defaults.baseURL = process.env.API_LOCATION;
axios.defaults.headers.common.Accept = 'application/json';

axios.interceptors.response.use((response) => {
  store.dispatch('errors/setBlockEmailSubmission', false);
  return response;
}, (error) => {
  if (!error.config.url.includes('disableErrorWarning=true') && !error.response.data.Data.Otp) {
    let message = error.message;

    if (error.response && error.response.data.Data) {
      if (error.response.data.Data.UiMessage) {
        message = error.response.data.Data.UiMessage;
      }

      if (error.response.data.Code) {
        message = `${message}`;
      }
    }

    const errorResponse = error.response.data;
    if (errorResponse && errorResponse.Code && errorResponse.Code.toLowerCase() === ERROR_SIMULATOR_CUSTOMER_WITH_DEBT) {
      store.dispatch('errors/setRedirectPageOnError', true);
      store.dispatch('errors/setRedirectPageOnErrorMessage', error.response.data.Data.UiMessage);
    } else if (errorResponse.Code.toLowerCase() === INVALID_IBAN) {
      store.dispatch('errors/setShowError', false);
    } else {
      store.dispatch('errors/setErrorMessage', message);
      if (error.response.data.Code === GENERIC_ERROR) {
        store.dispatch('errors/setErrorTitle', '');
      } else {
        store.dispatch('errors/setErrorTitle', null);
      }
      store.dispatch('errors/setShowError', true);
      store.dispatch('errors/setBlockEmailSubmission', true);
    }
  }

  store.dispatch('errors/setBlockEmailSubmission', true);
  return Promise.reject(error);
});

// Bind axios to Vue.
Vue.$http = axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return axios;
  }
});



// WEBPACK FOOTER //
// ./src/plugins/axios.js